/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAssistiveText64 = (props: Props) => (
  <Icon viewBox="0 0 64 64" {...props}>
    <path
      d="M47 51v9H2v-9zm-2 2H4v5h41zm13-37a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V20a4 4 0 0 1 4-4zm0 2H6a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h52a2 2 0 0 0 2-2V20a2 2 0 0 0-2-2zm-40 6v16h-1V24zm-1.953 3.549v1.716h-2.795V37h-2.028v-7.735H8.429v-1.716z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgAssistiveText64 as AssistiveText64 };
